export const transformEstadoToType = (estado) => {
	switch (estado) {
		case "A": {
			return "success";
		}
		case "BE": {
			return "warning";
		}
		case "BG": {
			return "warning";
		}
		case "BV": {
			return "warning";
		}
		case "C": {
			return "info";
		}
		case "R": {
			return "danger";
		}
		default: {
			return "info";
		}
	}
};

export const transformEstadoToText = (estado) => {
	switch (estado) {
		case "A": {
			return "Aprobado";
		}
		case "BE": {
			return "Baja";
		}
		case "BG": {
			return "Baja";
		}
		case "BV": {
			return "Baja";
		}
		case "C": {
			return "Cursando";
		}
		case "R": {
			return "Reprobada";
		}
		default: {
			return "Cursando";
		}
	}
};

export const transformCiclo = (ciclo) => {
	return `${ciclo[0].padEnd(2, "0")}${ciclo.slice(1, -1)}-${ciclo.slice(-1)}`;
};

export const transformTipo = (tipo) => {
	if (tipo === "OBL") {
		return "Obligatoria";
	}

	return "Optativa";
};
